module.exports = " <div class=go-center> <ul v-if=\"jobs !== -1 && jobs !== -2 && jobs.length !== 0\" class=jobs-list> <li v-for=\"job in jobs\" v-link=\"{ path: 'jobs/'+job.id }\" class=jobs-list-item> <p class=item-text> {{ job.title }} </p> </li> </ul> <h2 v-if=\"jobs.length === 0\" style=\"margin:0 2.5em\"> No Jobs available at the moment </h2> <h2 v-if=\"jobs === -1\" style=\"margin:0 2.5em\"> Loading ... </h2> <h2 v-if=\"jobs === -2\" style=\"margin:0 2.5em\"> Error loading jobs ... Please come back later </h2> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs.vue
// module id = 155
// module chunks = 2